

let windowWidth = window.innerWidth;

/**
 * .p-rich-header__image は position:absolute のため、親の高さが画像より小さくなる場合がある。
 * 画像の下端までの距離を測り、.p-rich-header の min-height を保証する。
 */
const adjustRichHeaderMinHeight = () => {
    const richHeader = document.querySelector('.p-rich-header');
    const imageFigure = richHeader?.querySelector('.p-rich-header__image');
    if (!richHeader || !imageFigure) return;

    // いったんリセットしてから測る（リサイズ時に過大な min-height が残らないように）
    richHeader.style.minHeight = '';

    const rhRect = richHeader.getBoundingClientRect();
    const imgRect = imageFigure.getBoundingClientRect();

    // .p-rich-header の top から画像 bottom までの距離を必要高さとして採用（+1 で「必ず大きく」）
    const requiredMinHeight = Math.ceil(imgRect.bottom - rhRect.top + 1);
    if (Number.isFinite(requiredMinHeight) && requiredMinHeight > 0) {
        richHeader.style.minHeight = `${requiredMinHeight}px`;
    }
};

let richHeaderAdjustRaf = null;
const scheduleAdjustRichHeaderMinHeight = () => {
    if (richHeaderAdjustRaf) cancelAnimationFrame(richHeaderAdjustRaf);
    richHeaderAdjustRaf = requestAnimationFrame(adjustRichHeaderMinHeight);
};

/**
 * .b-flows が折り返す場合、行末→次行頭をドット線でつなぐ
 */
const adjustFlowsConnectors = () => {
    const flowsList = document.querySelectorAll('.b-flows');
    if (!flowsList.length) return;

    flowsList.forEach((flows) => {
        const items = Array.from(flows.querySelectorAll('.b-flows__item'));
        if (!items.length) return;

        // 既存状態をリセット
        items.forEach((el) => el.classList.remove('is-row-end'));
        flows.querySelectorAll('.b-flows__connector').forEach((el) => el.remove());
        items.forEach((item) => {
            item
                .querySelectorAll('.b-flows__item-content')
                .forEach((content) => (content.style.minHeight = ''));
        });

        // 行ごとにグルーピング（top が近いものを同一行とみなす）
        const tolerance = 8;
        const rows = [];
        items.forEach((el) => {
            const rect = el.getBoundingClientRect();
            const top = rect.top;
            let row = rows.find((r) => Math.abs(r.top - top) < tolerance);
            if (!row) {
                row = { top, items: [] };
                rows.push(row);
            }
            row.items.push({ el, rect });
        });
        rows.sort((a, b) => a.top - b.top);

        if (rows.length <= 1) return; // 折り返しなし

        // 同じ行（横並び）の .b-flows__item-content の高さを揃える
        rows.forEach((row) => {
            const rowEls = row.items.map((x) => x.el);
            const contentElsByItem = rowEls.map((item) =>
                Array.from(item.querySelectorAll('.b-flows__item-content'))
            );
            const maxCount = Math.max(0, ...contentElsByItem.map((arr) => arr.length));

            for (let idx = 0; idx < maxCount; idx++) {
                const elsAtIdx = contentElsByItem.map((arr) => arr[idx]).filter(Boolean);
                if (!elsAtIdx.length) continue;
                const maxH = Math.max(...elsAtIdx.map((el) => el.getBoundingClientRect().height));
                elsAtIdx.forEach((el) => (el.style.minHeight = `${Math.ceil(maxH)}px`));
            }
        });

        // 高さ揃え後に最新の矩形を取得してコネクタを描画する
        const containerRect = flows.getBoundingClientRect();

        // 行末の三角矢印を消す（点線でつなぐため）
        for (let i = 0; i < rows.length - 1; i++) {
            const rowEnd = rows[i].items[rows[i].items.length - 1]?.el;
            if (rowEnd) rowEnd.classList.add('is-row-end');
        }

        // SVG で点線コネクタを描画
        const svgNS = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(svgNS, 'svg');
        svg.classList.add('b-flows__connector');
        svg.setAttribute('viewBox', `0 0 ${containerRect.width} ${containerRect.height}`);
        svg.setAttribute('preserveAspectRatio', 'none');

        for (let i = 0; i < rows.length - 1; i++) {
            const endEl = rows[i].items[rows[i].items.length - 1]?.el;
            const startEl = rows[i + 1].items[0]?.el;
            const end = endEl?.getBoundingClientRect();
            const start = startEl?.getBoundingClientRect();
            if (!end || !start) continue;

            const startX = (end.left + end.right) / 2 - containerRect.left;
            const startY = end.bottom - containerRect.top + 12;
            const endX = (start.left + start.right) / 2 - containerRect.left;
            const endY = start.top - containerRect.top - 12;
            const midY = (startY + endY) / 2;

            const path = document.createElementNS(svgNS, 'path');
            path.setAttribute('d', `M ${startX} ${startY} V ${midY} H ${endX} V ${endY}`);
            svg.appendChild(path);
        }

        flows.prepend(svg);
    });
};

let flowsAdjustRaf = null;
const scheduleAdjustFlowsConnectors = () => {
    if (flowsAdjustRaf) cancelAnimationFrame(flowsAdjustRaf);
    flowsAdjustRaf = requestAnimationFrame(adjustFlowsConnectors);
};

addEventListener('DOMContentLoaded', () => {

    // スムーススクロール
    $('a[href^="#"]').click(function(){
        var adjust = 0;
        var speed = 400;
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top + adjust;
        $('body,html').animate({scrollTop:position}, speed, 'swing');
        return false;
    });

    // ハンバーガーメニュー
    $('.l-header__toggle').click(function(){
        $(this).toggleClass('is-active');
        $('.l-header__nav').toggleClass('is-active');
        if ($(this).hasClass('is-active')) {
            $('.l-header').addClass('l-header--fixed-compulsory');
        } else {
            $('.l-header').removeClass('l-header--fixed-compulsory');
        }
    });

    // TOPページのみ スクロール時にヘッダーを角丸にする
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('.l-header--home').addClass('l-header--rounded');
        } else {
            $('.l-header--home').removeClass('l-header--rounded');
        }
    });
    $(window).scrollTop(0);
    if ($(window).scrollTop() > 100) {
        $('.l-header--home').addClass('l-header--rounded');
    } else {
        $('.l-header--home').removeClass('l-header--rounded');
    }

    // フッターの2階層メニューの項目数が5個以上の場合、ulにis-2colクラスを追加する
    $('.l-footer__menu > li > .sub-menu').each(function() {
        if ($(this).find('li').length >= 5) {
            $(this).addClass('is-2col');
        }
    });

    // .c-tag-select の開閉処理
    $('.c-tag-select__list').click(function() {
        $(this).toggleClass('is-active');
    });
    // .c-tag-select__list-item のクリック処理
    $('.c-tag-select__list-item').click(function() {
        $(".c-tag-select__list-item").removeClass('is-active');
        $(this).addClass('is-active');
        $(".c-tag-select__list").removeClass('is-active');
        const text = $(this).text();
        $(".c-tag-select__list-title span").text(text);
    });
    // escape, .c-tag-select の外側をクリックしたら閉じる
    $(document).click(function(e) {
        if (!$(e.target).closest('.c-tag-select__list').length) {
            $(".c-tag-select__list").removeClass('is-active');
        }
    });
    $(document).keyup(function(e) {
        if (e.key === 'Escape') {
            $(".c-tag-select__list").removeClass('is-active');
        }
    });
    $(document).keyup(function(e) {
        if (e.key === 'Escape') {
            $(".c-tag-select__list").removeClass('is-active');
        }
    });

    // ヘッダー、サブメニューの表示 / 非表示（PC）
    const headerSubmenuCloseDelay = 120;
    $('.l-header__nav-list > li').each(function() {
        let closeTimer = null;

        $(this)
            .on('mouseenter', function() {
                if (windowWidth >= 1150) {
                    if (closeTimer) {
                        clearTimeout(closeTimer);
                        closeTimer = null;
                    }
                    $(this)
                        .siblings('.is-active')
                        .removeClass('is-active')
                        .find('.sub-menu')
                        .removeClass('is-active');

                    $(this).addClass('is-active');
                    $(this).find('.sub-menu').addClass('is-active');
                }
            })
            .on('mouseleave', function() {
                if (windowWidth >= 1150) {
                    const $li = $(this);
                    closeTimer = setTimeout(function() {
                        $li.removeClass('is-active');
                        $li.find('.sub-menu').removeClass('is-active');
                    }, headerSubmenuCloseDelay);
                }
            });
    });

    // ヘッダー、サブメニューの表示 / 非表示（SP）
    const setupSpHeaderAccordion = (selector) => {
        $(selector).on('click', function(e) {
            if (windowWidth < 1150) {
                e.preventDefault();

                const $li = $(this).parent();
                const $submenu = $li.find('> .sub-menu');

                $li.toggleClass('is-active');
                $submenu.toggleClass('is-active');
            }
        });
    };

    // 1階層 → 2階層 を開閉
    setupSpHeaderAccordion('.l-header__nav-list > li:has(.sub-menu) > a');
    // 2階層 → 3階層 を開閉
    setupSpHeaderAccordion('.l-header__nav-list > li > .sub-menu > li:has(.sub-menu) > a');

    // リッチヘッダーの高さ調整（初期表示 + 画像読み込み完了時）
    scheduleAdjustRichHeaderMinHeight();
    const richHeaderImg = document.querySelector('.p-rich-header__image > img');
    if (richHeaderImg && !richHeaderImg.complete) {
        richHeaderImg.addEventListener('load', scheduleAdjustRichHeaderMinHeight, { once: true });
    }

    // フロー（折り返し時の点線コネクタ）
    scheduleAdjustFlowsConnectors();

    // .b-faq-item__question のクリック処理
    $('.b-faq-item__question').click(function() {
        $(this).toggleClass('is-open');
        $(this).next('.b-faq-item__answer').toggleClass('is-open');
    });
});

addEventListener('resize', () => {
    windowWidth = window.innerWidth;
    scheduleAdjustRichHeaderMinHeight();
    scheduleAdjustFlowsConnectors();
});

// 画像・フォント等の読み込み後にも再調整（初期表示でサイズが確定しないケース対策）
addEventListener('load', () => {
    scheduleAdjustRichHeaderMinHeight();
    scheduleAdjustFlowsConnectors();
});
